import {CreatePublicServiceConsentRequest} from '@di-shared/api/di/__generated';
import PublicServiceConsentsDetail from '@di-shared/features/public-service/PublicServcieConsentsDetail';

export interface PublicServiceConsentsDetailPageProps {
  vin: string;
  category: CreatePublicServiceConsentRequest.category;
}

function PublicServiceConsentsDetailPage({vin, category}: PublicServiceConsentsDetailPageProps) {
  const queryString = new URLSearchParams(window.location.search);
  const nextUrl = decodeURIComponent(queryString.get('nextUrl') || '');
  return (
    <div className="wrap">
      <PublicServiceConsentsDetail
        vin={vin}
        category={category}
        nextUrl={nextUrl}
      />
    </div>
  );
}

export default PublicServiceConsentsDetailPage;
